<template>
  <div
    :class="sidebarClasses"
    :data-background-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div class="logo">
      <a
        class="simple-text logo-mini"
        href="/"
      >
        <div class="logo-img">
          <img
            :src="logo"
            alt="logo"
          >
        </div>
      </a>

      <router-link
        class="cropped-company-logo simple-text logo-normal"
        to="/"
        tag="a"
      >
        <img
          :src="companyLogo"
          class="lg:m-0 m-auto"
          alt="company logo"
        >
      </router-link>
    </div>
    <div
      ref="sidebarScrollArea"
      class="sidebar-wrapper"
    >
      <slot />

      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item
            v-for="(link, linkIndex) in sidebarLinks"
            :key="link.title + linkIndex"
            :link="link"
          >
            
            <sidebar-item
              v-for="(subLink, subLinkIndex) in link.children"
              :key="subLink.title + subLinkIndex"
              :link="subLink"
            />
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import label from "@consts/label";
export default {
  props: {
    companyLogo: {
      type: String,
      default: label.croppedCompanyLogo
    },
    title: {
      type: String,
      default: "Paper Dashboard Pro"
    },
    type: {
      type: String,
      default: "sidebar",
      validator: value => {
        let acceptedValues = ["sidebar", "navbar"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["white", "brown", "black"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: "success",
      validator: value => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: "static/img/tp_logo.png"
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sidebarClasses() {
      if (this.type === "sidebar") {
        return "sidebar";
      } else {
        return "collapse navbar-collapse off-canvas-sidebar";
      }
    },
    navClasses() {
      if (this.type === "sidebar") {
        return "nav";
      } else {
        return "nav navbar-nav";
      }
    }
  },
  mounted() {
    this.initScrollBarAsync();
  },
  beforeUnmount() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  methods: {
    async initScrollBarAsync() {
      await import("perfect-scrollbar/dist/css/perfect-scrollbar.css");
      const PerfectScroll = await import("perfect-scrollbar");
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    }
  }
};
</script>
<style>
.logo-img {
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 6px;
}

.sidebar .logo .logo-img img {
  display: block;
  max-width: none;
  width: 100%;
  height: auto;
}

.sidebar .logo .cropped-company-logo {
  padding: 0;
}
.sidebar .logo .cropped-company-logo img {
  max-width: 150px;
}

@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
